import { FC } from 'react';

import { Box } from '@mui/material';

interface SliderAppendDotsProps {
  dots: JSX.Element[];
}

const SliderAppendDots: FC<SliderAppendDotsProps> = ({ dots }) => {
  return (
    <Box
      component="ul"
      sx={{
        listStyleType: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& li': {
          '&.slick-active button': {
            bgcolor: 'primary.main',
          },
          '& button': {
            m: 0.5,
            width: 12,
            height: 12,
            fontSize: 0,
            border: 'none',
            cursor: 'pointer',
            borderRadius: '50%',
            background: 'rgba(255, 255, 255, 0.1)',
            '&:before': {
              display: 'none',
            },
          },
        },
      }}
    >
      {dots}
    </Box>
  );
};

export default SliderAppendDots;
